var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo",style:(_vm.photoStyle)},[_c('img',{directives:[{name:"gallery",rawName:"v-gallery",value:('chat-' + _vm.chatId),expression:"'chat-' + chatId"}],attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }